module.exports = {
  "heroBanner.title": "Bienvenid@ a DevLand",
  "heroBanner.message":
    "DevLand es una comunidad por y para desarrolladores de software. ¡Únete a nosotros y empieza a construir la web del futuro!",
  "heroBanner.visitDiscordButton": "Visitanos en discord",
  "sessionBox.createAccountButton": "Crear cuenta",
  "sessionBox.importAccountButton": "Importar cuenta",
  "alertAccountCreationModal.title": "Antes de crear tu cuenta",
  "alertAccountCreationModal.text1":
    "DevLand Network utiliza un modelo de autenticación anónima basada en las direcciones de Stellar.",
  "alertAccountCreationModal.text2":
    "Un par de claves públicas y privadas serán generadas para ti. La clave pública funciona como un usuario, mientras que la clave privada como una contraseña.",
  "alertAccountCreationModal.text3":
    "Estas claves pueden ser utilizadas también en cualquier cartera de Stellar, importando la clave privada en la misma.",
  "alertAccountCreationModal.text4":
    "Se te proporcionarán ambas claves para que las guardes de manera segura. La clave privada será guardada también en el navegador, pero encriptada para que otros usuarios con acceso a tu equipo no puedan usar tu cuenta. Para realizar este paso te pediremos una contraseña que servirá para encriptar y desencriptar la clave privada cada vez que haya que usarla.",
  "alertAccountCreationModal.text5":
    "Ten en cuenta que nosotros no tenemos en ningún momento acceso a tu clave privada. Es tu responsabilidad conservarla de manera segura. Si la pierdes o es comprometida no podremos hacer nada.",
  "alertAccountCreationModal.text6":
    "Puedes encontrar más información en la sección de Preguntas Frecuentes.",
  "alertAccountCreationModal.button": "Entiendo lo que supone, deseo continuar",
  "createAccountModal.title": "Crea tu cuenta",
  "createAccountModal.privateKey": "Clave privada:",
  "createAccountModal.publicKey": "Clave pública:",
  "createAccountForm.passwordLabel":
    "Introduce una contraseña para encriptar tu clave privada",
  "createAccountForm.repeatPasswordLabel": "Repite la contraseña",
  "createAccountForm.emptyPasswordError": "Error: La contraseña está vacía.",
  "createAccountForm.shortPasswordError":
    "Error: La contraseña es menor de 8 caracteres.",
  "createAccountForm.differentPasswordsError":
    "Error: Las contraseñas no coinciden.",
  "createAccountForm.submitButton": "Encriptar clave privada",
  "importAccountModal.title": "Importa tu clave privada",
  "importAccountForm.privateKeyLabel": "Clave privada de tu cuenta Stellar",
  "importAccountForm.passwordLabel": "Contraseña para encriptarla",
  "importAccountForm.repeatPasswordLabel": "Repite la contraseña",
  "importAccountForm.emptyPrivateKeyError":
    "Error: La clave privada está vacía.",
  "importAccountForm.emptyPasswordError": "Error: La contraseña está vacía.",
  "importAccountForm.shortPasswordError":
    "Error: La contraseña es menor de 8 caracteres.",
  "importAccountForm.differentPasswordsError":
    "Error: Las contraseñas no coinciden.",
  "importAccountForm.submitButton": "Importar cuenta",
  "accountPage.title": "Tu cuenta",
  "accountPage.text1":
    "El sistema de autenticación está basado en la red de Stellar.",
  "accountPage.text2":
    "La clave privada que recibiste al crear la cuenta representa tu contraseña. No la pierdas ya que nosotros no podemos recuperarla.",
  "accountPage.text3":
    "La pública representa tu usuario, aquí puedes verla completa:",
  "accountPage.activateAccountText":
    "Tu cuenta no está activa. Para activarla debes enviar 3 XLM (lúmenes, la moneda de stellar) a tu dirección pública y establecer una relación de confianza con DEVP, el token de DevLand.",
  "accountPage.activateAccountButton": "Activar cuenta",
  "accountPage.revealPrivateKeyButton": "Mostrar clave privada",
  "accountPage.logoutButton": "Desvincular cuenta (logout)",
  "accountPage.notLoggedInWarning":
    "Crea o importa tu cuenta para acceder a esta página",
  "showPrivateKeyModal.passwordLabel":
    "Introduce tu contraseña para desencriptar tu clave privada",
  "showPrivateKeyModal.wrongPasswordError":
    "ERROR: Parece que la contraseña introducida es incorrecta.",
  "showPrivateKeyModal.revealPrivateKeyButton": "Revelar clave privada",
  "activateAccountModal.title": "Activar cuenta",
  "activateAccountModal.operationLabel": "Operación:",
  "activateAccountModal.operation": "Aceptar confianza en token DEVP",
  "activateAccountModal.balance": "Balance actual:",
  "activateAccountModal.maxFee": "Tasa máxima aplicable:",
  "activateAccountModal.signButton": "Firmar operación de activación",
  "createUserModal.title": "Añade tus datos de usuario",
  "createUserForm.username": "Nombre de usuario",
  "createUserForm.firstName": "Nombre",
  "createUserForm.lastName": "Apellido",
  "createUserForm.submitButton": "Crear cuenta",
  "dropdownMenu.aboutDevland": "Acerca de DevLand",
  "dropdownMenu.aboutDevp": "Acerca de DEVP",
  "dropdownMenu.aboutSnippet": "Acerca de SNIPPET",
  "dropdownMenu.roadmap": "Roadmap",
  "dropdownMenu.faq": "Preguntas frecuentes",
  "dropdownMenu.profile": "Perfil",
  "dropdownMenu.wallet": "Monedero",
  "dropdownMenu.account": "Cuenta",
  "dropdownMenu.logout": "Cerrar sesión",
  "footer.about": "Información",
  "footer.about.DevLand": "Acerca de DevLand",
  "footer.about.Devp": "Acerca de DEVP",
  "footer.about.Snippet": "Acerca de SNIPPET",
  "footer.about.faq": "Preguntas frecuentes",
  "footer.roadmap": "Hoja de ruta",
  "footer.socialMedia": "Redes Sociales",
  "footer.tokenDisclaimer":
    "Los tokens DEVP y SNIPPET no son productos de inversión, no están respaldados por activos reales ni poseen valor real. Son utilidades de DevLand emitidas como tokens nativos de Stellar destinadas a ser usadas en la plataforma de devland.network y en otras herramientas relacionadas del ecosistema Stellar.",
}
